import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  containerBox: {
    width: '100%',
    maxHeight: '32.5rem',
    background: '#fff',
    overflow: 'auto',
  },
  descriptionList: {
    textShadow: `0px 3px 6px ${theme.palette.grey[100]}`,
    '& .MuiListItemText-primary': {
      fontSize: 14,
      fontWeight: 500,
      color: theme.palette.primary.dark,
    },
    '& .MuiListItemText-secondary': {
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.primary.dark,
      '& ol': {
        listStyle: 'lower-alpha',
        paddingLeft: 25
      }
    }
  }
}));
